import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/layer/enable/many/layer.enable.many.mutation.gql"
import type {
  LayerEnableManyMutation,
  LayerEnableManyMutationVariables,
} from "@/v2-backoffice-client/layer/enable/many/__types__/layer.enable.many.mutation"

type Options = MutationHookOptions<
  LayerEnableManyMutation,
  LayerEnableManyMutationVariables
>

export function useLayerEnableManyMutation(options?: Options) {
  return useMutation<LayerEnableManyMutation, LayerEnableManyMutationVariables>(
    mutation,
    options,
  )
}
